// extracted by mini-css-extract-plugin
export var button = "index-module--button--2U7Rs";
export var buttonImg = "index-module--buttonImg--248u2";
export var menuSection = "index-module--menuSection--3jipH";
export var menuSectionOpen = "index-module--menuSectionOpen--VtzAt";
export var menuSection__nav = "index-module--menuSection__nav--2CM6-";
export var menuSection__achor = "index-module--menuSection__achor--13R-4";
export var flagsContainer = "index-module--flagsContainer--3yJqV";